var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 13c.126 0 .228.103.228.229v.742a.228.228 0 01-.228.229H3.544a.228.228 0 01-.228-.229v-.742c0-.126.102-.228.228-.228h8.686zm.97-11.6a1.4 1.4 0 011.4 1.4v7.4a1.4 1.4 0 01-1.4 1.4H2.8a1.4 1.4 0 01-1.4-1.4V2.8a1.4 1.4 0 011.4-1.4h10.4zM2.8 2.6a.2.2 0 00-.2.2v7.4c0 .11.09.2.2.2h10.4c.11 0 .2-.09.2-.2V2.8c0-.11-.09-.2-.2-.2H2.8z"
  })));
}
export default SvgIconSystem;